import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useEventRegistrationMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: Api.IEventRegistrationSurvey) => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ eventRegistration }: { eventRegistration: Api.IEventRegistrationSurvey }) => {
			return userSession.webServiceHelper.callAsync<Api.IEventRegistrationSurvey>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/eventRegistration`,
				}),
				'POST',
				eventRegistration
			);
		},
		onError,
		onSuccess,
	});
};
